import { MemberGroups } from "shared-types";
import authorizationService from "../services/authorization/authorizationService";
import { UserAttributes } from "../services/authorization";

export default function checkIsPerformer() {
  return [
    MemberGroups.performer,
    MemberGroups.yPerformer,
    MemberGroups.graduatePerformer,
  ].includes(authorizationService.getUserAttribute(UserAttributes.MemberGroup));
}
